function l(t, e) {
  console.error(t, `

`, e.outerHTML);
}
function b(t, e) {
  console.warn(t, `

`, e.outerHTML);
}
const o = {
  error: l,
  warn: b
}, f = "position: absolute; width: 1px; height: 1px; padding: 0px; margin: -1px; overflow: hidden; clip: rect(0px, 0px, 0px, 0px); white-space: nowrap; border-width: 0px;";
function c(t, e) {
  return t.tagName.toLowerCase() === e;
}
function s(t, e, n) {
  const i = new CustomEvent(e, { detail: n });
  t.dispatchEvent(i);
}
function p(t) {
  t.directive("accordion", (e, { value: n, modifiers: i }) => {
    n === "item" ? g(e, t, { open: i.includes("open") }) : n === "trigger" ? m(e, t) : n === "content" ? v(e, t) : x(e, t, {
      type: i.includes("single") ? "single" : "multiple",
      loop: i.includes("loop"),
      orientation: i.includes("horizontal") ? "horizontal" : "vertical"
    });
  });
}
function x(t, e, n) {
  e.bind(t, {
    "x-data"() {
      return {
        __root: t,
        loop: n.loop,
        orientation: n.orientation || "vertical",
        triggers: [],
        openItems: /* @__PURE__ */ new Set(),
        toggleItem(i) {
          n.type === "single" && this.openItems.has(i) ? this.openItems.delete(i) : n.type === "single" && !this.openItems.has(i) ? (this.openItems.clear(), this.openItems.add(i)) : n.type === "multiple" && this.openItems.has(i) ? this.openItems.delete(i) : n.type === "multiple" && !this.openItems.has(i) && this.openItems.add(i), this.openItems = new Set(this.openItems);
        }
      };
    },
    "x-id"() {
      return ["tb-accordion"];
    },
    "@keydown.home.prevent.stop"() {
      var i;
      (i = this.triggers.at(0)) == null || i.focus();
    },
    "@keydown.end.prevent.stop"() {
      var i;
      (i = this.triggers.at(-1)) == null || i.focus();
    }
  });
}
function g(t, e, n) {
  e.bind(t, {
    "x-data"() {
      return {
        __item: t,
        open: n.open ?? !1
      };
    },
    "x-init"() {
      this.__root || o.error(
        "x-accordion:item must be placed inside an x-accordion",
        t
      ), n.open && this.openItems.add(t);
    },
    "x-id"() {
      return ["tb-accordion-trigger", "tb-accordion-content"];
    },
    "x-effect"() {
      const i = this.openItems.has(t);
      i !== this.open && s(t, "accordion:change", {
        open: i
      }), this.open = i;
    },
    ":data-state"() {
      return this.open ? "open" : "closed";
    }
  });
}
function m(t, e) {
  e.bind(t, {
    "x-init"() {
      this.__item || o.error(
        "x-accordion:trigger must be placed inside an x-accordion:item",
        t
      ), c(t, "button") || o.error("x-accordion:trigger must be a <button> element", t), this.triggers.push(t);
    },
    ":id"() {
      return this.$id("tb-accordion-trigger");
    },
    ":aria-controls"() {
      return this.$id("tb-accordion-content");
    },
    ":aria-expanded"() {
      return this.open;
    },
    ":data-state"() {
      return this.open ? "open" : "closed";
    },
    "@click"() {
      this.toggleItem(this.__item);
    },
    "@keydown.up.prevent.stop"() {
      var n;
      if (this.orientation === "vertical") {
        const i = this.triggers.indexOf(t);
        if (i >= 0) {
          const a = this.loop ? i - 1 : Math.max(i - 1, 0);
          (n = this.triggers.at(a)) == null || n.focus();
        }
      }
    },
    "@keydown.down.prevent.stop"() {
      var n;
      if (this.orientation === "vertical") {
        const i = this.triggers.indexOf(t);
        if (i >= 0) {
          const a = this.loop ? (i + 1) % this.triggers.length : Math.min(i + 1, this.triggers.length - 1);
          (n = this.triggers.at(a)) == null || n.focus();
        }
      }
    },
    "@keydown.left.prevent.stop"() {
      var n;
      if (this.orientation === "horizontal") {
        const i = this.triggers.indexOf(t);
        if (i >= 0) {
          const a = this.loop ? i - 1 : Math.max(i - 1, 0);
          (n = this.triggers.at(a)) == null || n.focus();
        }
      }
    },
    "@keydown.right.prevent.stop"() {
      var n;
      if (this.orientation === "horizontal") {
        const i = this.triggers.indexOf(t);
        if (i >= 0) {
          const a = this.loop ? (i + 1) % this.triggers.length : Math.min(i + 1, this.triggers.length - 1);
          (n = this.triggers.at(a)) == null || n.focus();
        }
      }
    },
    "x-effect"() {
      s(t, "accordion:change", {
        open: this.open
      });
    }
  });
}
function v(t, e) {
  e.bind(t, {
    "x-init"() {
      this.__item || o.error(
        "x-accordion:content must be placed inside an x-accordion:item",
        t
      );
    },
    ":id"() {
      return this.$id("tb-accordion-content");
    },
    role: "region",
    ":aria-labelledby"() {
      return this.$id("tb-accordion-trigger");
    },
    ":data-state"() {
      return this.open ? "open" : "closed";
    },
    "x-show"() {
      return this.open;
    },
    "x-effect"() {
      s(t, "accordion:change", {
        open: this.open
      });
    }
  });
}
function k(t) {
  t.directive("checkbox", (e, { value: n, modifiers: i, expression: a }) => {
    n === "indicator" ? w(e, t) : n === "label" ? $(e, t) : _(e, t, {
      checked: i.includes("checked"),
      value: a
    });
  });
}
function _(t, e, n) {
  e.bind(t, {
    "x-data"() {
      return {
        __root: t,
        checked: n.checked,
        value: n.value || "on"
      };
    },
    "x-id"() {
      return ["tb-checkbox-indicator"];
    },
    ":data-state"() {
      return this.checked ? "checked" : "unchecked";
    },
    "x-effect"() {
      s(t, "checkbox:change", {
        checked: this.checked
      });
    }
  });
}
function w(t, e) {
  e.bind(t, {
    "x-init"() {
      this.__root || o.error(
        "x-checkbox:indicator must be placed inside an x-checkbox",
        t
      ), c(t, "button") || o.error("x-checkbox:indicator must be a <button> element", t);
      const n = document.createElement("input");
      t.insertAdjacentElement("afterend", n), y(n, e);
    },
    ":id"() {
      return this.$id("tb-checkbox-indicator");
    },
    role: "checkbox",
    type: "button",
    ":aria-checked"() {
      return this.checked;
    },
    ":value"() {
      return this.value;
    },
    ":data-state"() {
      return this.checked ? "checked" : "unchecked";
    },
    "@keydown.space.prevent.stop"() {
      this.checked = !this.checked;
    },
    "@click"() {
      this.checked = !this.checked;
    },
    "x-effect"() {
      s(t, "checkbox:change", {
        checked: this.checked
      });
    }
  });
}
function y(t, e) {
  e.bind(t, {
    type: "checkbox",
    "aria-hidden": "true",
    style: f,
    tabIndex: "-1",
    ":value"() {
      return this.value;
    },
    ":checked"() {
      return this.checked;
    }
  });
}
function $(t, e) {
  e.bind(t, {
    "x-init"() {
      this.__root || o.error(
        "x-checkbox:label must be placed inside an x-checkbox",
        t
      ), c(t, "label") || o.error("x-checkbox:label must be a <label> element", t);
    },
    ":for"() {
      return this.$id("tb-checkbox-indicator");
    },
    ":data-state"() {
      return this.checked ? "checked" : "unchecked";
    }
  });
}
function T(t) {
  t.directive("dialog", (e, { value: n }) => {
    n === "trigger" ? O(e, t) : n === "content" ? M(e, t) : n === "overlay" ? L(e, t) : n === "title" ? E(e, t) : n === "description" ? R(e, t) : n === "close" ? z(e, t) : I(e, t);
  });
}
function I(t, e) {
  e.bind(t, {
    "x-data"() {
      return {
        open: !1,
        __root: t
      };
    },
    "x-id"() {
      return ["tb-dialog-content", "tb-dialog-title", "tb-dialog-description"];
    },
    ":data-state"() {
      return this.open ? "open" : "closed";
    },
    "x-effect"() {
      s(t, "dialog:change", { open: this.open });
    }
  });
}
function O(t, e) {
  e.bind(t, {
    "x-init"() {
      this.__root || o.error("x-dialog:trigger must be placed inside an x-dialog.", t), c(t, "button") || o.error("x-dialog:trigger must be a <button> element.", t);
    },
    "@click"() {
      this.open = !this.open;
    },
    ":aria-expanded"() {
      return !!this.open;
    },
    ":data-state"() {
      return this.open ? "open" : "closed";
    },
    "aria-haspopup": "dialog",
    ":aria-controls"() {
      return this.$id("tb-dialog-content");
    },
    "x-effect"() {
      s(t, "dialog:change", { open: this.open });
    }
  });
}
function M(t, e) {
  e.bind(t, {
    "x-init"() {
      this.__root || o.error("x-dialog:content must be placed inside an x-dialog.", t);
    },
    "x-data"() {
      return {
        __content: t
      };
    },
    ":id"() {
      return this.$id("tb-dialog-content");
    },
    role: "dialog",
    tabindex: -1,
    "aria-modal": !0,
    ":aria-labelledby"() {
      return this.$id("tb-dialog-title");
    },
    ":aria-describedby"() {
      return this.$id("tb-dialog-description");
    },
    ":data-state"() {
      return this.open ? "open" : "closed";
    },
    "x-show"() {
      return this.open;
    },
    "x-trap.noscroll.inert"() {
      return this.open;
    },
    "@keydown.escape.prevent.stop"() {
      this.open = !1;
    },
    "x-effect"() {
      s(t, "dialog:change", { open: this.open });
    }
  });
}
function L(t, e) {
  e.bind(t, {
    "x-init"() {
      this.__content || o.error(
        "x-dialog:overlay must be placed inside an x-dialog:content.",
        t
      );
    },
    "x-show"() {
      return this.open;
    },
    "@click"() {
      this.open = !1;
    },
    "aria-hidden": !0
  });
}
function E(t, e) {
  e.bind(t, {
    "x-init"() {
      this.__content || o.error(
        "x-dialog:title must be placed inside an x-dialog:content.",
        t
      );
    },
    ":id"() {
      return this.$id("tb-dialog-title");
    }
  });
}
function R(t, e) {
  e.bind(t, {
    "x-init"() {
      this.__content || o.error(
        "x-dialog:description must be placed inside an x-dialog:content.",
        t
      );
    },
    ":id"() {
      return this.$id("tb-dialog-description");
    }
  });
}
function z(t, e) {
  e.bind(t, {
    "x-init"() {
      this.__content || o.error(
        "x-dialog:close must be placed inside an x-dialog:content.",
        t
      ), c(t, "button") || o.error("x-dialog:close must be a <button> element.", t);
    },
    "@click"() {
      this.open = !1;
    }
  });
}
function C(t) {
  t.directive("flyout", (e, { value: n, modifiers: i }) => {
    n === "trigger" ? S(e, t) : n === "content" ? q(e, t) : N(e, t, {
      hoverable: i.includes("hoverable")
    });
  });
}
function N(t, e, n) {
  e.bind(t, {
    "x-data"() {
      return {
        open: !1,
        __root: t
      };
    },
    "x-id"() {
      return ["tb-flyout-content"];
    },
    ":data-state"() {
      return this.open ? "open" : "closed";
    },
    "@click.outside"() {
      this.open && (this.open = !1);
    },
    "x-effect"() {
      s(t, "flyout:change", {
        open: this.open
      });
    }
  }), n.hoverable && e.bind(t, {
    "x-data"() {
      return {
        closeOnMouseLeaveTimeout: null
      };
    },
    "@mouseenter"() {
      this.closeOnMouseLeaveTimeout && clearTimeout(this.closeOnMouseLeaveTimeout), this.open = !0;
    },
    "@mouseleave"() {
      this.closeOnMouseLeaveTimeout && clearTimeout(this.closeOnMouseLeaveTimeout), this.closeOnMouseLeaveTimeout = setTimeout(() => {
        this.open = !1;
      }, 200);
    }
  });
}
function S(t, e) {
  e.bind(t, {
    "x-init"() {
      this.__root || o.error("x-flyout:trigger must be placed inside an x-flyout", t), c(t, "button") || o.warn("x-flyout:trigger must be a <button> element", t);
    },
    ":aria-expanded"() {
      return this.open;
    },
    ":data-state"() {
      return this.open ? "open" : "closed";
    },
    "aria-haspopup": "dialog",
    ":aria-controls"() {
      return this.$id("tb-flyout-content");
    },
    "@click"() {
      this.open = !this.open;
    },
    "x-effect"() {
      s(t, "flyout:change", {
        open: this.open
      });
    }
  });
}
function q(t, e) {
  e.bind(t, {
    "x-data"() {
      return {
        __content: t
      };
    },
    "x-init"() {
      this.__root || o.error("x-flyout:content must be placed inside an x-flyout", t);
    },
    ":id"() {
      return this.$id("tb-flyout-content");
    },
    role: "dialog",
    ":data-state"() {
      return this.open ? "open" : "closed";
    },
    "x-show"() {
      return this.open;
    },
    "@focusout"(n) {
      t.contains(n.relatedTarget) || (this.open = !1);
    },
    "x-effect"() {
      s(t, "flyout:change", {
        open: this.open
      });
    }
  });
}
function F(t) {
  t.directive("section", (e, { value: n }) => {
    n === "title" ? H(e, t) : U(e, t);
  });
}
function U(t, e) {
  e.bind(t, {
    "x-id"() {
      return ["tb-section-title"];
    },
    "x-data"() {
      return {
        __root: t
      };
    },
    ":aria-labelledby"() {
      return this.$id("tb-section-title");
    }
  });
}
function H(t, e) {
  e.bind(t, {
    "x-init"() {
      this.__root || console.warn("x-section:title must be placed inside an x-section.", t);
    },
    ":id"() {
      return this.$id("tb-section-title");
    }
  });
}
function P(t) {
  t.directive("progress", (e, { value: n }) => {
    n === "indicator" ? j(e, t) : Y(e, t);
  });
}
function Y(t, e) {
  let n = t.getAttribute("data-valuemin"), i = t.getAttribute("data-valuemax"), a = t.getAttribute("data-valuenow");
  const r = t.getAttribute("data-valuetext");
  if (!n) {
    o.error("x-progress is missing data-valuemin.", t);
    return;
  }
  if (!i) {
    o.error("x-progress is missing data-valuemax.", t);
    return;
  }
  if (!a) {
    o.error("x-progress is missing data-valuenow.", t);
    return;
  }
  if (n = parseFloat(n), i = parseFloat(i), a = parseFloat(a), isNaN(n)) {
    o.error("x-progress data-valuemin must be a number.", t);
    return;
  }
  if (isNaN(i)) {
    o.error("x-progress data-valuemax must be a number.", t);
    return;
  }
  if (isNaN(a)) {
    o.error("x-progress data-valuenow must be a number.", t);
    return;
  }
  if (n > i) {
    o.error(
      "x-progress data-valuemin must be less than data-valuemax.",
      t
    );
    return;
  }
  if (a < n || a > i) {
    o.error(
      "x-progress data-valuenow must be between data-valuemin and data-valuemax.",
      t
    );
    return;
  }
  const u = (a - n) / (i - n) * 100;
  e.bind(t, {
    "x-data"() {
      return {
        __root: t,
        progress: u
      };
    },
    role: "progressbar",
    "aria-valuemin": n,
    "aria-valuemax": i,
    "aria-valuenow": a,
    "aria-valuetext": r
  });
}
function j(t, e) {
  e.bind(t, {
    "x-init"() {
      this.__root || o.error(
        "x-progress:indicator must be placed inside an x-progress.",
        t
      ), t.style.setProperty("--tb-progress", `${this.progress}%`);
    }
  });
}
function D(t) {
  t.directive("tabs", (e, { value: n, modifiers: i, expression: a }) => {
    n === "list" ? G(e, t, {
      loop: i.includes("loop"),
      automatic: i.includes("automatic"),
      orientation: i.includes("vertical") ? "vertical" : "horizontal"
    }) : n === "tab" ? J(e, t, { value: a }) : n === "panel" ? K(e, t, { value: a }) : B(e, t, {
      default: a
    });
  });
}
function B(t, e, n) {
  e.bind(t, {
    "x-data"() {
      return {
        __root: t,
        tabs: [],
        activeTab: n.default || null
      };
    },
    "x-id"() {
      return ["tb-tabs-tab", "tb-tabs-panel"];
    },
    "x-effect"() {
      s(t, "tabs:change", {
        tab: this.activeTab
      });
    }
  });
}
function G(t, e, n) {
  e.bind(t, {
    "x-init"() {
      this.__root || o.error("x-tabs:tab must be placed inside an x-tabs.", t);
    },
    "x-data"() {
      return {
        __list: t,
        loop: n.loop || !1,
        automatic: n.automatic || !1,
        orientation: n.orientation || "horizontal"
      };
    },
    role: "tablist",
    tabindex: 0,
    "x-effect"() {
      s(t, "tabs:change", {
        tab: this.activeTab
      });
    }
  });
}
function J(t, e, n) {
  if (!n.value)
    return o.error("x-tabs:tab must have a value.", t);
  e.bind(t, {
    "x-data"() {
      return {
        value: n.value
      };
    },
    "x-init"() {
      this.__list || o.error("x-tabs:tab must be placed inside an x-tabs:list.", t), c(t, "button") || o.error("x-tabs:tab must be a <button> element.", t), this.activeTab || (this.activeTab = this.value), this.tabs.push(t);
    },
    ":id"() {
      return `${this.$id("tb-tabs-tab")}-${this.value}`;
    },
    role: "tab",
    ":tabindex"() {
      return this.activeTab === this.value ? "0" : -1;
    },
    ":aria-selected"() {
      return this.activeTab === this.value;
    },
    ":aria-controls"() {
      return `${this.$id("tb-tabs-panel")}-${this.value}`;
    },
    ":data-state"() {
      return this.activeTab === this.value ? "active" : "inactive";
    },
    "@click"() {
      this.activeTab = this.value;
    },
    "@keydown.home.prevent.stop"() {
      const i = this.tabs.at(0);
      i && i.focus(), i && this.automatic && i.click();
    },
    "@keydown.end.prevent.stop"() {
      const i = this.tabs.at(-1);
      i && i.focus(), i && this.automatic && i.click();
    },
    "@keydown.left.prevent.stop"() {
      if (this.orientation === "horizontal") {
        const i = this.tabs.indexOf(t);
        if (i >= 0) {
          const a = this.loop ? i - 1 : Math.max(i - 1, 0), r = this.tabs.at(a);
          r && r.focus(), r && this.automatic && r.click();
        }
      }
    },
    "@keydown.right.prevent.stop"() {
      if (this.orientation === "horizontal") {
        const i = this.tabs.indexOf(t);
        if (i >= 0) {
          const a = this.loop ? (i + 1) % this.tabs.length : Math.min(i + 1, this.tabs.length - 1), r = this.tabs.at(a);
          r && r.focus(), r && this.automatic && r.click();
        }
      }
    },
    "@keydown.up.prevent.stop"() {
      if (this.orientation === "vertical") {
        const i = this.tabs.indexOf(t);
        if (i >= 0) {
          const a = this.loop ? i - 1 : Math.max(i - 1, 0), r = this.tabs.at(a);
          r && r.focus(), r && this.automatic && r.click();
        }
      }
    },
    "@keydown.down.prevent.stop"() {
      if (this.orientation === "vertical") {
        const i = this.tabs.indexOf(t);
        if (i >= 0) {
          const a = this.loop ? (i + 1) % this.tabs.length : Math.min(i + 1, this.tabs.length - 1), r = this.tabs.at(a);
          r && r.focus(), r && this.automatic && r.click();
        }
      }
    },
    "x-effect"() {
      s(t, "tabs:change", {
        open: this.activeTab === this.value
      });
    }
  });
}
function K(t, e, n) {
  if (!n.value)
    return o.error("x-tabs:panel must have a value.", t);
  e.bind(t, {
    "x-init"() {
      this.__root || o.error("x-tabs:panel must be placed inside an x-tabs", t);
    },
    "x-data"() {
      return {
        value: n.value,
        open: this.activeTab === n.value
      };
    },
    ":id"() {
      return `${this.$id("tb-tabs-panel")}-${this.value}`;
    },
    role: "tabpanel",
    ":tabindex"() {
      return this.open ? "0" : -1;
    },
    ":data-state"() {
      return this.open ? "active" : "inactive";
    },
    ":aria-labelledby"() {
      return `${this.$id("tb-tabs-tab")}-${this.value}`;
    },
    "x-show"() {
      return this.open;
    },
    "x-effect"() {
      const i = this.activeTab === this.value;
      i !== this.open && s(t, "tabs:change", {
        open: i
      }), this.open = i;
    }
  });
}
function Q(t) {
  t.directive("link", (e, { value: n, modifiers: i }) => {
    const a = i.includes("nested");
    n === "current" ? d(e, t, { nested: a }) : n === "external" && h(e, t, { nested: a });
  });
}
function d(t, e, n) {
  if (!n.nested && !c(t, "a"))
    return o.error(
      "x-link directive can only be used on <a> elements, unless nested.",
      t
    );
  if (!n.nested && c(t, "a") && !t.href)
    return o.error(
      "x-link directive requires an 'href' attribute, unless nested.",
      t
    );
  if (c(t, "a")) {
    const i = new URL(t.href), a = new URL(window.location.href), r = i.origin === a.origin && i.pathname.replace(/\/$/, "") === a.pathname.replace(/\/$/, "");
    e.bind(t, {
      ":aria-current"() {
        if (r)
          return "page";
      },
      ":data-current"() {
        return r;
      }
    });
  }
  n.nested && t.querySelectorAll("a").forEach((i) => {
    d(i, e, n);
  });
}
function h(t, e, n) {
  if (!n.nested && !c(t, "a"))
    return o.error(
      "x-link directive can only be used on <a> elements, unless nested.",
      t
    );
  if (!n.nested && c(t, "a") && !t.href)
    return o.error(
      "x-link directive requires an 'href' attribute, unless nested.",
      t
    );
  if (c(t, "a")) {
    const i = t.origin !== window.location.origin;
    e.bind(t, {
      ":target"() {
        if (i)
          return "_blank";
      },
      ":rel"() {
        if (i)
          return "noopener noreferrer";
      },
      ":data-external"() {
        return i;
      }
    });
  }
  n.nested && t.querySelectorAll("a").forEach((i) => {
    h(i, e, n);
  });
}
function V(t) {
  p(t), k(t), T(t), C(t), F(t), P(t), Q(t), D(t);
}
export {
  V as default
};
